import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-sky-100 bg-white/95 shadow-sm backdrop-blur" data-id="element-299" data-mp="232nfsn0fptzi">
      <div className="bg-primary px-3 py-1.5 text-center font-display text-[10px] font-bold tracking-wide text-white sm:text-xs md:text-sm" data-id="element-300" data-mp="1y4vej2dwgvin">
        🇦🇷 Sistema N°1 para Profesionales de la Rehabilitación en Argentina
      </div>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-medium text-slate-500 md:flex" data-id="element-301" data-mp="2qrohzsioc8wc">
        <span className="flex items-center gap-1.5" data-id="element-302" data-mp="2h2oga1csezeg">
          <ZapIcon className="h-3.5 w-3.5 text-accent" data-id="element-303" data-mp="2h13nag64foip" /> Acceso en 5 minutos
        </span>
        <span className="text-sky-300" data-id="element-304" data-mp="2c2sco38059zf">·</span>
        <span className="flex items-center gap-1.5" data-id="element-305" data-mp="39iz6y44uabll">
          <LockIcon className="h-3.5 w-3.5 text-accent" data-id="element-306" data-mp="39jr2jeyfs9bv" /> Pago seguro
        </span>
        <span className="text-sky-300" data-id="element-307" data-mp="34r7qimfedm96">·</span>
        <span className="flex items-center gap-1.5" data-id="element-308" data-mp="34q65bp4o3jdq">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-309" data-mp="26aj453ucts3" /> Garantía de 7 días
        </span>
      </div>
    </header>;
}